import React, { useEffect, useRef, useState } from 'react'
import SnackbarComponent from '../../Services/SnackbarComponent'
import DeleteConfirmAlert from "../../Services/AlertComponent";
import { WebService } from '../../Services/WebService';
import StaticListComponent from '../../Services/StaticListComponent';
import { NoRecordTemplate } from '../../Services/TableComponent';
import { useDispatch, useSelector } from "react-redux";
import { StandardConst } from '../../Services/StandardConst';
import Button from "react-bootstrap/esm/Button";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import ActionButton from '../../Services/ActionButton';
import { PageInfo } from '../PageInfo';
import AddEditInterviewType from './AddEditInterviewType';

const ManageInterviewType = () => {

    const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
    const [permission, SetPermission] = useState({});
    const [interviewTypeData, setInterviewTypeData] = useState([]);
    PageInfo({ pageTitle: "Manage Interview Type" });
    const Roles = useSelector((s) => s.auth.AssignRole ?? {});
    const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});

    useEffect(() => {
        SetPermission({
            ManageAdd: true, // ActionPermission("Visitor Type - Add"),
            ManageEdit: true, // ActionPermission("Visitor Type - Edit"),
            ManageDelete: true, // ActionPermission("Visitor Type - Delete"),
        });
    }, [permissionList]);
    
    const [accesslevelTypeList, setAccesslevelTypeList] = useState([]);

    // const fetchAllAccesslevelTypeDetails = async (AccessLevelTypeId) => {
    //     if(AccessLevelTypeId !== null){
    //         const data = await WebService({
    //             endPoint: `CommonUtility/Edit/accessleveltype`,
    //             dispatch,
    //         });
    //         setAccesslevelTypeList(data);
    //     }
    // }

    const fetchInterviewType = async () => {
        const data = await WebService({
            endPoint: `CommonUtility/staticinterviewtypes`,
            dispatch,
        });
        setInterviewTypeData(data);
        dispatch(ConfigurationflowStatusUpdate());
    }

    useEffect(() => {
        // fetchAllAccesslevelTypeDetails();
        fetchInterviewType();
    }, []);


    const refSnackbar = useRef();
    const ref = useRef();
    const MasterPageName = "Manage Interview Type";
    const confirmMessage = MasterPageName + " Deleted successfully";
    const addEditModalRef = useRef();

    const AddButtonText = "Interview Type";
    const dispatch = useDispatch();
    const onDelete = async (StaticInterviewTypeId) => {
        await WebService({
            endPoint: `CommonUtility/staticinterviewtypes?StaticInterviewTypeId=${StaticInterviewTypeId}`,
            method: "DELETE",
            dispatch,
        });
        refSnackbar.current.setOpenSnackBar();
        await fetchInterviewType();
    };

    const [bData,] = React.useState([
        {
            title: "Recruitments",
            hrefLink: "#",
        },
        {
            title: "Interview Type",
            hrefLink: "#",
        },
    ]);

    const columns = [
        {
            Text: "Interview Type Name",
            Value: "InterviewType"
        },
        {
            Text: "Interview Type Code",
            Value: "InterviewTypeCode"
        },
        {
            Text: "Action",
            cssClass: "text-center td-width-100",
            isVisiable: permission.ManageEdit || permission.ManageDelete,
            render: (dr) => (
                <>
                    <ActionButton
                        onClick={() => fnEdit(dr.StaticInterviewTypeId)}
                        disabled={!permission.ManageEdit}
                        IconName="Edit"
                        IconTooltip={"Edit Interview Type"}
                        id={`btnAccessLevelEdit_${dr.StaticInterviewTypeId}`}
                    />
                    <ActionButton
                        onClick={(e) =>
                            ref.current.confirmAlert(
                                "Delete", //Confirm button text
                                "Are You Sure", // Text if Alert
                                "Do you want to delete " + dr?.InterviewType, // Message of Alert
                                dr.StaticInterviewTypeId  // Endpoint to hit for delete
                            )}
                        disabled={!permission.ManageDelete}
                        IconName="Delete"
                        IconTooltip={"Delete Interview Type"}
                        id={`btnAccessLevelDelete_${dr.StaticInterviewTypeId}`}
                    />
                </>
            ),
        },
    ];

    // if (Roles[0] === StandardConst.SystemRole.SuperAdmin) {
    //     columns.splice(1, 0, {
    //         Text: "Access",
    //         Value: "CompanyName"
    //     });
    // }

    const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);


    return (
        <>
            <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
            <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
            <StaticListComponent
                columns={columns}
                records={interviewTypeData}
                bData={bData}
                MasterPageName={MasterPageName}
                AddButtonText={AddButtonText}
                noRecordCss="p-0"
                noRecordFound={
                    <NoRecordTemplate
                        headerValue={StandardConst.AccessLevelheaderValueNoResults}
                        subHeaderValue={StandardConst.AccessLevelSubHeader}
                        imageUrl={StandardConst.imageNoRecordsFound}
                        actionButton={
                            <>
                                {permission.ManageAdd && (
                                    <Button id="NoRecordFoundAddAccessLevel" variant="outline-primary" onClick={() => fnEdit(0)}>
                                        Add {AddButtonText}
                                    </Button>
                                )}
                            </>
                        }
                    />
                }
                onAddEvent={() => fnEdit()}
                IsAddButtonVisible={permission?.ManageAdd}
                isSearchRequired={true}
                allowSerialNo={true}
            ></StaticListComponent>
            <AddEditInterviewType
                callBackEvent={async () => await fetchInterviewType()}
                ref={addEditModalRef}
            ></AddEditInterviewType>
        </>
    )
}

export default ManageInterviewType